module.exports = __webpack_public_path__ + "img/rubish.ba4a792c.png";